import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {LoadingOutlined} from "@ant-design/icons"
import "./loader.css"

const Loader=(props)=>{ 
return(
    <>
        <div className="loader-div" style={{
            backgroundColor: props.backgroundColor ?  props.backgroundColor : "#fff"}}>
            <LoadingOutlined className="loader"/>
        </div>
    </>
);
}
export default Loader;